const duplicateTranslationKey = (key: string): string => key;

export const translationStatistics_da_part3 = {
  topicMergeTargetLabel: "Flyt samtaler til",
  topicMergeConfirm: "Flyt og slet",
  topicDeleteConfirmTitle: "Slet emne?",
  topicDeleteConfirmDescription: "Emnet har ingen samtaler tilknyttet og fjernes permanent.",
  topicNoTopics: "Ingen emner endnu. Tilføj et emne nedenfor.",
  topicsScopeOrg: "Fælles for hele organisationen",
  topicsScopeBrand: "Egne emner for dette brand",
  topicsScopeChatbot: "Kun denne chatbot",
  topicsCustomizeForChatbot: "Tilpas kun for denne chatbot",
  topicsCustomizeForBrand: "Tilpas for dette brand",
  topicsBrandUsesOrg: "Dette brand bruger organisationens fælles emner.",
  topicSubtagsLabel: "Tags",
  topicSubtagsHint: "Tags AI'en må bruge for dette emne (tags(...)).",
  topicAddTagPlaceholder: "Tilføj tag...",
  topicRemoveTag: "Fjern tag",
  freshdeskTagsTitle: "Freshdesk tags",
  freshdeskTagsDescription: "Tags AI'en må sætte på Freshdesk-tickets via email-automatisering.",
  livechatStatistics: "Live Chat Statistikker",
  // Live Chat Statistics individual translations
  // Live Chat Statistics individual translations
  totalLivechatConversations: "Total livechat samtaler",
  avgLivechatPerDay: "Gennemsnitlig livechat per dag",
  livechatPercentage: "Livechat procent",
  avgResponseTime: "Gennemsnitlig responstid",
  totalResponses: "Total svar",
  livechatStatisticsDescription:
    "Følg livechat-volumen, responstider og kundefeedback for de valgte chatbots.",
  dailyLivechatSessions: "Daglige livechat-sessioner",
  livechatSessionsByHour: "Livechat-sessioner efter tidspunkt",
  livechatStatusDistribution: "Statusfordeling",
  livechatStatusWaiting: "Venter",
  livechatStatusActive: "Aktiv",
  livechatStatusClosed: "Lukket",
  livechatWaitingSessions: "Ventende sessioner",
  livechatActiveSessions: "Aktive sessioner",
  livechatClosedSessions: "Lukkede sessioner",
  avgWaitTime: "Gennemsnitlig ventetid",
  avgHandlingTime: "Gennemsnitlig håndteringstid",
  livechatTotalRatings: "Livechat-vurderinger",
  viewLivechatSessions: "Se livechat-sessioner",
  noLivechatStatistics: "Ingen livechat-statistik fundet for den valgte periode.",
  // Live Chat Statistics tooltips
  // Live Chat Statistics tooltips
  totalLivechatConversationsTooltip: "Det totale antal samtaler håndteret gennem livechat",
  avgLivechatPerDayTooltip: "Gennemsnitligt antal livechat samtaler per dag",
  livechatPercentageTooltip: "Procent af alle samtaler der gik videre til livechat",
  avgResponseTimeTooltip: "Gennemsnitlig tid for agenter at svare på brugermeddelelser",
  totalResponsesTooltip: "Totalt antal svar sendt af agenter i livechat",
  livechatWaitingSessionsTooltip: "Antal livechat-sessioner der venter på en agent",
  livechatActiveSessionsTooltip: "Antal livechat-sessioner der er aktive lige nu",
  livechatClosedSessionsTooltip: "Antal afsluttede livechat-sessioner",
  avgWaitTimeTooltip: "Gennemsnitlig tid fra livechat-anmodning til en agent deltager",
  avgHandlingTimeTooltip: "Gennemsnitlig tid fra agenten deltager til livechat-sessionen lukkes",
  livechatTotalRatingsTooltip: "Antal kundevurderinger indsendt efter livechat-sessioner",
  save: "Gem",
  [duplicateTranslationKey("cancel")]: "Annuller",

  // Notifications page

  // Notifications page
  notificationsPageTitle: "Notifikationer",
  notificationsPageDescription:
    "Opsæt automatiske email notifikationer når der er usædvanlig aktivitet på din chatbot. Vælg et emne, angiv hvor stor en procentvis stigning der skal udløse notifikationen, og bestem tidsperioden for målingen. Du vil modtage en email når aktiviteten overstiger den angivne procentstigning sammenlignet med den normale aktivitet i den valgte periode.",
  notificationsLabelTopic: "Emne",
  notificationsLoadingTopics: "Indlæser emner...",
  notificationsSelectTopic: "Vælg et emne",
  notificationsNoTopics: "Ingen emner fundet. Emner genereres automatisk fra dine samtaler.",
  notificationsLabelPercentIncrease: "Procent Stigning",
  notificationsSelectPercent: "Vælg procent stigning",
  notificationsLabelTimePeriod: "Tidsperiode",
  notificationsSelectTimePeriod: "Vælg tidsperiode",
  notificationsPeriod6Hours: "6 timer",
  notificationsPeriod12Hours: "12 timer",
  notificationsPeriod24Hours: "24 timer",
  notificationsPeriod3Days: "3 dage",
  notificationsPeriod7Days: "7 dage",
  notificationsLabelEmail: "Email",
  notificationsEmailPlaceholder: "Indtast email adresse",
  notificationsSaving: "Gemmer...",
  notificationsSaveButton: "Gem Notifikationsindstillinger",
  notificationsYourSettings: "Dine Notifikationsindstillinger",
  notificationsLoadingSettings: "Indlæser indstillinger...",
  notificationsNoSettings: "Du har ingen aktive notifikationsindstillinger endnu.",
  notificationsCreateFirst: "Opret din første notifikation ovenfor.",
  notificationsCardTopic: "Emne",
  notificationsCardIncrease: "Stigning",
  notificationsCardPeriod: "Periode",
  notificationsCardEmail: "Email",
  notificationsCreatedAt: "Oprettet",
  notificationsDeleteButton: "Slet",
  notificationsDeleteTitle: "Slet notifikation",
  notificationsErrorFetchTopics: "Fejl ved hentning af emner",
  notificationsErrorFetchSettings: "Fejl ved hentning af notifikationsindstillinger",
  notificationsSaveSuccess: "Notifikationsindstillinger gemt succesfuldt",
  notificationsSaveError: "Fejl ved gemning af indstillinger",
  notificationsLoginRequired: "Du skal være logget ind for at slette notifikationer",
  notificationsDeleteSuccess: "Notifikationsindstilling slettet succesfuldt",
  notificationsDeleteError: "Fejl ved sletning af notifikation",
  // Notification topics: one row per topic; `emne` is canonical for API/DB. Dropdown order = this array order (not alphabetical). Same `emne` sequence in en; only `label` differs.
  // Notification topics: one row per topic; `emne` is canonical for API/DB. Dropdown order = this array order (not alphabetical). Same `emne` sequence in en; only `label` differs.
  notificationTopics: [
    { emne: "Abonnement & medlemskab", label: "Abonnement & medlemskab" },
    { emne: "Annullering", label: "Annullering" },
    { emne: "Andet", label: "Andet" },
    { emne: "Åbningstider", label: "Åbningstider" },
    { emne: "Bestilling", label: "Bestilling" },
    { emne: "Betaling", label: "Betaling" },
    { emne: "Booking", label: "Booking" },
    { emne: "Butikker", label: "Butikker" },
    { emne: "FAQ", label: "FAQ" },
    { emne: "Fitness rådgivning", label: "Fitness rådgivning" },
    { emne: "Fortrydelsesret", label: "Fortrydelsesret" },
    { emne: "Garanti", label: "Garanti" },
    { emne: "Generel", label: "Generel" },
    { emne: "Informationsforespørgsel", label: "Informationsforespørgsel" },
    { emne: "Kalorieberegner/Kostplan", label: "Kalorieberegner/Kostplan" },
    { emne: "Kampagner & rabatter", label: "Kampagner & rabatter" },
    { emne: "Kontakt", label: "Kontakt" },
    { emne: "Kundeservice", label: "Kundeservice" },
    { emne: "Lagerstatus", label: "Lagerstatus" },
    { emne: "Levering", label: "Levering" },
    { emne: "Medlemskab", label: "Medlemskab" },
    { emne: "Ordre", label: "Ordre" },
    { emne: "Pris og rabat", label: "Pris og rabat" },
    { emne: "Problem med shoppen", label: "Problem med shoppen" },
    { emne: "Produkt anbefaling", label: "Produkt anbefaling" },
    { emne: "Produktinformation", label: "Produktinformation" },
    { emne: "Profil", label: "Profil" },
    { emne: "Refundering", label: "Refundering" },
    { emne: "Reklamation", label: "Reklamation" },
    { emne: "Reservation", label: "Reservation" },
    { emne: "Returnering", label: "Returnering" },
    { emne: "Support", label: "Support" },
    { emne: "Teknisk", label: "Teknisk" },
    { emne: "Tilbud", label: "Tilbud" },
    { emne: "Vask selv", label: "Vask selv" },
    { emne: "Contact & support", label: "Contact & support" },
    { emne: "Fejl på shoppen", label: "Fejl på shoppen" },
    { emne: "Kompatabilitet", label: "Kompatibilitet" },
    { emne: "Kontakt & support", label: "Kontakt & support" },
    { emne: "Konto & login", label: "Konto & login" },
    { emne: "Produktvalg", label: "Produktvalg" },
    { emne: "Support og Kontakt", label: "Support og Kontakt" },
  ],

  // Business hours and time period filter translations,
};
